"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.Number = exports.IconWrapper = exports.Bubble = exports.BellWrapper = void 0;
const styled_components_1 = __importStar(require("styled-components"));
exports.BellWrapper = styled_components_1.default.div `
  display: flex;
  justify-content: center;
  align-items: center;
  position: relative;
  width: ${({ theme }) => theme.space.s300};
  height: ${({ theme }) => theme.space.s300};

  ${({ $forceMobile }) => {
    if (!$forceMobile) {
        return (0, styled_components_1.css) `
        @media (min-width: ${({ theme }) => theme.breakpoint.desktop}) {
          width: 1.75rem;
          height: 1.75rem;
        }
      `;
    }
}}
`;
exports.Bubble = styled_components_1.default.div `
  width: ${({ theme }) => theme.space.s150};
  height: ${({ theme }) => theme.space.s150};
  border: ${({ theme }) => theme.border.s100} solid transparent;
  border-radius: ${({ theme }) => theme.radius.s400};
  background-color: ${({ theme }) => theme.colors.accent.base};
  position: absolute;
  top: -5px;
  right: -2px;

  ${({ $forceMobile }) => {
    if (!$forceMobile) {
        return (0, styled_components_1.css) `
        @media (min-width: ${({ theme }) => theme.breakpoint.desktop}) {
          top: -4px;
          right: -1px;
        }
      `;
    }
}}

  display: flex;
  justify-content: center;
  align-items: center;

  &.notification-bell-transition-enter {
    opacity: 0;
  }

  &.notification-bell-transition-enter-active {
    opacity: 1;
    transition: opacity 500ms ease-in-out;
  }

  &.notification-bell-transition-exit {
    opacity: 1;
  }

  &.notification-bell-transition-exit-active {
    opacity: 0;
    transition: opacity 500ms ease-in-out;
  }
`;
exports.IconWrapper = styled_components_1.default.div `
  width: ${({ theme }) => theme.space.s300};
  height: ${({ theme }) => theme.space.s300};

  ${({ $active, theme }) => {
    if ($active) {
        return (0, styled_components_1.css) `
        svg > path {
          fill: ${theme.colors.main.base};
        }
      `;
    }
}}

  ${({ $forceMobile }) => {
    if (!$forceMobile) {
        return (0, styled_components_1.css) `
        @media (min-width: ${({ theme }) => theme.breakpoint.desktop}) {
          width: 1.75rem;
          height: 1.75rem;
        }
      `;
    }
}}
`;
exports.Number = styled_components_1.default.span `
  color: ${({ theme }) => theme.colors.neutral.n0};
  ${({ theme }) => theme.typography.body.boldMicroText};
`;
